export default __webpack_public_path__ + "static/media/how-it-works-1.7f0ce970.png";